<template>
  <div class="ori-image-component">
    <div class="thumb-image">
      <img
        v-lazy="data.src"
        class="app-lazyload-transparent"
        title="微博营销 创意灵感"
        alt="微博营销 创意灵感"
        @click="preview"
      />
    </div>
    <modal-base
      v-if="popShow"
      bg-color="rgba(0, 0, 0, 0.85)"
      :lock-scroll="false"
      @wrapper-click="popShow = false"
    >
      <div class="preview-image">
        <img :src="data.src" />
      </div>
      <div class="close-btn" @click="popShow = false">
        <i class="iconfont icon-guanbianniu"></i>
      </div>
    </modal-base>
  </div>
</template>

<script>
import ModalBase from '@/components/common/ModalBase'

export default {
  components: {
    ModalBase
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      popShow: false
    }
  },
  methods: {
    preview() {
      this.popShow = true
    }
  }
}
</script>

<style lang="scss" scoped>
.ori-image-component {
  .thumb-image {
    width: 278px;
    height: 503px;
    overflow: hidden;
    border-radius: 8px;
    cursor: pointer;
    img {
      float: left;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .preview-image {
    position: absolute;
    width: 505px;
    left: 50%;
    top: 24px;
    bottom: 24px;
    margin-left: -252.5px;
    box-sizing: border-box;
    overflow: hidden;
    text-align: center;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .close-btn {
    position: absolute;
    top: 32px;
    right: 32px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: rgba(142, 144, 145, 0.85);
    line-height: 56px;
    text-align: center;
    cursor: pointer;
    color: #363636;
    &:hover {
      background-color: #3352fe;
      color: #ffffff;
    }
    i {
      font-size: 34px;
    }
  }
}
</style>
